import styled, { css } from 'styled-components';
import color from '../../../config/colors.json';

const poppins = css`
    font-family: 'Poppins', sans-serif;
    font-style: normal;
`;

const textTitleStyle = css`
    ${poppins};
    font-size: 14px;
    line-height: 20px;
`;

export const ConversionTitle = styled.em`
    ${textTitleStyle};
    margin-bottom: 13px;
    text-align: center;
    display: block;
`;

export const LastDataDate = styled.span`
	display: flex;
	justify-content: flex-end;
	> em {
    	${textTitleStyle};
	}
`;

export const TitleLead = styled.div`
    ${poppins}
    text-align: left;
    letter-spacing: 0;
    color: ${color.dark};
    font-size: ${({ fontSize }) => (fontSize || '18px')};
    font-weight: 600;
    margin-bottom: ${({ marginBottom }) => (marginBottom || '23px')};
    @media screen and (max-width: 1919px) {
        font-size: 16px;
}
`;

export const MyConvesionTitle = styled.span`
    ${poppins};
    font-size: 13px;
    line-height: 19px;
    margin: 19px 0 14px;
`;

export const MyConversionPercentage = styled.span`
    ${poppins};
    font-size: 17px;
    line-height: 24px;
    color: ${color.green};
`;

export const MyConversion = styled.span`
    ${poppins};
    color: ${color.lightGrey13};
    font-size: 12px;
    line-height: 13px;
    text-align: center;
`;
